export const environment = {
  production: true,
  mode: 'PROD',
  syncServerUrl: 'https://prod-3.egylis.com/synchronization/synchronize/V1',
  syncApiKey: 'LEMKEN_201907_ROULEAUX_PROD_hsqpvdpxnmwr',
  geoServerUrl: require('../../package.json').moveon.geoServerUrl,
  geoSqlFile: require('../../package.json').moveon.geoSqlFile,
  version: require('../../package.json').version,
  name: require('../../package.json').name,
  log: {
    console : {
      INFO: true,
      TRACK: true,
      LOG: true,
      LOG_LEVEL: 1,
      ERROR: true,
      ERROR_LEVEL: 1
    },
    server : {
      INFO: true,
      TRACK: false,
      LOG: true,
      LOG_LEVEL: 1,
      ERROR: true,
      ERROR_LEVEL: 1
    }
  },
  logServerUrl: require('../../package.json').moveon.logServerUrl,
  logInfoTime: 60,
  logGtag: require('../../package.json').moveon.logGtag,
  logGtagId: require('../../package.json').moveon.logGtagId
};
